import React, { type FC } from "react";
import { printPdf } from "../../../../../../../common-deprecated/utils/pdfUtils";
import { useUscSelector } from "../../../../../redux/store";
import Icon from "../../../../../../shared-components/toyota/styles/atoms/Icon";
import SaveCodeCtaButton from "./SaveCodeCtaButton";
import { type UscTrackingLocation, trackClickPdf } from "../../../../../utils/tracking";
import { getUscPdfUrl } from "../../../../../utils/pdpUtils";

type PdfButtonPropsType = {
    buttonVariant: "basket-cta" | "icon-text";
    trackingLocation: UscTrackingLocation;
};

const PdfButton: FC<PdfButtonPropsType> = ({ buttonVariant, trackingLocation }) => {
    const vehicle = useUscSelector((state) => state.vehicle);
    const commonSettings = useUscSelector((state) => state.commonSettings);
    const hidePrintButton = useUscSelector((state) => state.uscSettings.hidePrintButton);

    if (hidePrintButton) return null;

    const onPrint = (tyCode?: string | null, tab?: Window | null): void => {
        const pdfUrl = getUscPdfUrl(commonSettings, vehicle, tyCode);
        printPdf(pdfUrl, commonSettings, tab);
        trackClickPdf(trackingLocation, vehicle.type);
    };

    return (
        <SaveCodeCtaButton
            buttonVariant={buttonVariant}
            onClick={onPrint}
            label="uscBasketCtaPrint"
            icon={<Icon variant="book" />}
            openNewTab
        />
    );
};

export default PdfButton;
